import { Addon } from 'AppTypes';
import { calculatePrice } from '../utils/calculatePrice';
import { Card } from './card';
import clsx from 'clsx';
import { useState } from 'react';



const activeClasses = 'border border-primary-purplish-blue bg-neutral-magnolia';
const percentage = 66;
const addons: Addon[] = [
	{
		name: 'Online service',
		description: 'Access to multiplayer games',
		monthlyPrice: 1,
	},
	{
		name: 'Large storage',
		description: 'Extra 1TB of cloud save',
		monthlyPrice: 2,
	},
	{
		name: 'Customizable profile',
		description: 'Custom theme on your profile',
		monthlyPrice: 2,
	},
];

interface AddonsProps {
	selectedAddons: Addon[];
	monthly: boolean;
	updateAddons: (addon: Addon) => void;
}

export const Addons = ({
	updateAddons,
	monthly,
  data,
  setData,
	selectedAddons,
}: any) => {

  //usestate for percentage input

  const [percentageInput,setPercentageInput]=useState(data.objective_percentage)

	return (
		<section className="flex flex-col w-full gap-4">
			<h2>ELECTRIC CARS IN 2030</h2>
			<p>Percentage of electric cars in 2030</p>
    <div style={{textAlign:"center"}}>


    <div className="flex items-center gap-1" style={{textAlignLast:"center",justifyContent:"center",paddingTop:"20px"}}>

<input
  type="number"
  id="Quantity"
   value={
    percentageInput
   }
   onChange={
    (e) => {
      setData(
        {
          ...data,
          objective_percentage: e.target.value,
        }
      )
      setPercentageInput(
        Number(e.target.value)
      )
    }
   }

/>


</div>
<input  className="rounded-lg overflow-hidden appearance-none bg-gray-400 h-3 " style={{width:"400px",marginTop:"20px"}} type="range"  min="0" max="100" step="1"
   value={
    percentageInput
   }
   onChange={
    (e) => {
      setData(
        {
          ...data,
          objective_percentage: e.target.value,
        }
      )
      setPercentageInput(
        Number(e.target.value)
      )

    }

   } />



    </div>
		</section>
	);
};
